import React from 'react';

import { COLORS } from '@constants/colors';

interface RadioOption {
  value: string;
  label: string;
  description?: string;
}

interface RadioGroupProps {
  label: string;
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  label,
  options,
  value,
  onChange,
  className = '',
}) => {
  return (
    <div className={className}>
      <label
        className="block text-sm font-medium mb-3"
        style={{ color: COLORS.charcoal }}
      >
        {label}
      </label>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {options.map(option => (
          <label
            key={option.value}
            className={`relative flex items-center p-4 rounded-xl cursor-pointer transition-all duration-300 border-2 ${
              value === option.value
                ? 'border-blue-500 bg-blue-50 shadow-md'
                : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm'
            }`}
          >
            <input
              type="radio"
              name={`radio-${label}`}
              value={option.value}
              checked={value === option.value}
              onChange={e => onChange(e.target.value)}
              className="sr-only"
            />
            <div className="flex items-center">
              <div
                className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
                  value === option.value
                    ? 'border-blue-500 bg-blue-500'
                    : 'border-gray-300 bg-white'
                }`}
              >
                {value === option.value && (
                  <div className="w-2 h-2 bg-white rounded-full flex-shrink-0"></div>
                )}
              </div>
              <div>
                <span
                  className={`text-sm font-semibold ${
                    value === option.value ? 'text-blue-700' : 'text-gray-700'
                  }`}
                >
                  {option.label}
                </span>
                {option.description && (
                  <p className="text-xs text-gray-500 mt-0.5">
                    {option.description}
                  </p>
                )}
              </div>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioGroup;
